<template>
  <div>
    <v-dialog v-model="documentModal" max-width="500px">
      <ManageDocument
        :documentId="selectedDocument.id"
        :parentFolderId="selectedFolderId"
        @close="documentModal = false"
        @success="reloadDataKeepingState"
        @totalFilesUpdate="$emit('updateSumFiles')"
        :key="documentDialogKey"
      />
    </v-dialog>

    <v-dialog v-model="folderModal" max-width="500px">
      <ManageFolder
        :folderId="selectedFolderId"
        :parentFolderId="parentFolderId"
        @close="folderModal = false"
        @success="reloadDataKeepingState"
        :key="folderDialogKey"
      />
    </v-dialog>

    <v-expansion-panels
      v-if="!loading && specificFolder.length > 0"
      v-model="panel"
    >
      <DragDiv
        :list="specificFolder"
        group="common-folder-items"
        ghost-class="ghost"
        animation="200"
        style="width: 100%"
        draggable=".my-list-common-folder-items"
        @change="ChangeOrder"
      >
        <div class="my-folder-list" ref="subFolderList">
          <v-expansion-panel
            v-for="(item, i) in specificFolder"
            :key="i"
            :readonly="item.isDocument"
            class="my-list-common-folder-items"
          >
            <v-expansion-panel-header
              :hide-actions="item.isDocument"
              :style="`${item.isDocument ? 'cursor: default' : ''}`"
            >
              <div
                v-if="item.isDocument"
                class="d-flex justify-center"
                style="max-width: 20px; margin-top: -6px"
              >
                <v-checkbox
                  class="mr-1"
                  dense
                  small
                  v-model="item.selected"
                  hide-details
                  @click="addToDownloadList(item)"
                ></v-checkbox>
              </div>
              <span
                v-if="item.isDocument"
                style="margin-bottom: -4px; margin-left: 6px"
              >
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-file-document-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <span v-else>
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-folder-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <div
                :style="`display: flex; justify-content: flex-end; ${
                  item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
                }`"
              >
                <span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        @click.stop="
                          item.isDocument
                            ? editDocument(item)
                            : updateFolder(item)
                        "
                        v-if="
                          institution.userType < 3 || institution.userType == 8
                        "
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-pencil-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-menu v-if="!item.isDocument" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltipOn }">
                          <v-btn
                            class="ma-1"
                            small
                            depressed
                            color="primary"
                            v-on="{ ...on, ...tooltipOn }"
                            v-if="
                              institution.userType < 3 ||
                              institution.userType == 8
                            "
                          >
                            <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar</span>
                      </v-tooltip>
                    </template>
                    <v-list nav dense>
                      <v-list-item-group
                        active-class="info--text text--accent-2"
                      >
                        <v-list-item
                          v-for="(actionItem, index) in addTableItems"
                          :key="index"
                          @click.stop="actionItem.action(item)"
                          width="100%"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon>{{ actionItem.icon }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{
                            actionItem.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>

                  <v-tooltip v-if="item.isDocument" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        @click.stop="getFile(item)"
                      >
                        <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir documento</span>
                  </v-tooltip>

                  <v-tooltip v-if="item.isDocument" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="item.extension === 'pdf'"
                        class="ma-1"
                        :readonly="item.validated"
                        :color="item.validated ? 'secondary' : 'primary'"
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="validateDoc(item)"
                        small
                      >
                        <v-icon dark> mdi-check </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      item.validated
                        ? 'Documento validado'
                        : 'Validar documento'
                    }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="#ff4f64"
                        v-if="
                          institution.userType < 3 || institution.userType == 8
                        "
                        @click.stop="
                          item.isDocument
                            ? deleteDocument(item)
                            : deleteFolder(item)
                        "
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-trash-can-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </span>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <CommonSubFolder
                v-if="!item.isDocument"
                :folder="item"
                :add-table-items="addTableItems"
                @updateSumFiles="$emit('updateSumFiles')"
                @edit-document="editDocument"
                @update-folder="updateFolder"
                @get-file="getFile"
                @validate-doc="validateDoc"
                @delete-document="deleteDocument"
                @delete-folder="deleteFolder"
                @add-to-download-list="addToDownloadList"
                @open-add-folder-modal="openAddFolderModal"
                @open-add-doc-modal="openAddDocModal"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card v-if="totalPages > 1" v-intersect="getMoreData"> </v-card>
        </div>
      </DragDiv>
    </v-expansion-panels>

    <div
      v-else-if="!loading && specificFolder.length === 0"
      class="text-center pa-4"
    >
      <span>Esta pasta está vazia</span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import CommonSubFolder from './commonSubFolder.vue'
import ManageDocument from '../manageDocument.vue'
import ManageFolder from '../manageFolder.vue'

export default {
  name: 'commonFolder',
  components: { CommonSubFolder, ManageDocument, ManageFolder },

  props: {
    folder: Object,
    index: Number,
    active: Boolean,
  },

  data() {
    return {
      sizes: [10, 30, 90, 180],
      totalItems: null,
      totalItensOnPage: 1,
      totalPages: null,
      pageSize: 10,
      page: 1,
      parentFolderId: false,
      addTableItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openAddDocModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openAddFolderModal,
        },
      ],
      apiService: new ApiService(),
      specificFolder: [],
      filterListFolderWithDoc: {
        institutionId: null,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      user: {},
      documentModal: false,
      folderModal: false,
      documentDialogKey: false,
      folderDialogKey: false,
      selectedDocument: {},
      selectedFolderId: null,
      panel: [],
      institution: {},
    }
  },

  watch: {
    folder() {
      this.reloadDataKeepingState()
    },

    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getSpecificFolder(this.folder)
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getSpecificFolder(this.folder)
    },
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getSpecificFolder(this.folder)
  },

  methods: {
    async getMoreData(entries, observer, previous) {
      if (entries[0].isIntersecting) {
        this.filterListFolderWithDoc.page++

        if (this.filterListFolderWithDoc.page <= this.totalPages) {
          const initialHeight = this.$refs.subFolderList.scrollHeight
          const institutionId = JSON.parse(
            localStorage.getItem('institution')
          ).id
          this.filterListFolderWithDoc.institutionId = institutionId
          this.filterListFolderWithDoc.folderId = this.folder.id

          try {
            const response = await this.apiService.get(
              `CommonAreaDocumentFolder/list-with-doc`,
              this.filterListFolderWithDoc
            )
            this.specificFolder.push(...response.content.data)

            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.subFolderList.scrollTop = initialHeight
              }, 100)
            })
          } catch (error) {
            console.error('Erro ao carregar dados da pasta:', error)
          }
        }
      }
    },

    async reloadDataKeepingState() {
      const panel = this.panel
      this.getSpecificFolder(this.folder)
      this.panel = panel

      this.documentModal = false
      this.folderModal = false
    },

    async ChangeOrder(event) {
      if (event.moved) {
        const findItem = event.moved.element
        findItem.order = event.moved.newIndex

        if (findItem.filePath) await this.updateDocOrder(findItem)
        else await this.updateFolderOrder(findItem)
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocumentFolder/change-order', model)
    },

    async getSpecificFolder(folder) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.filterListFolderWithDoc.institutionId = institutionId
      this.filterListFolderWithDoc.folderId = folder.id
      this.loading = true

      try {
        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.specificFolder = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Erro ao carregar dados da pasta:', error)
      }
    },

    editDocument(item) {
      this.documentDialogKey = !this.documentDialogKey
      this.selectedDocument = { ...item }
      this.documentModal = true
    },

    updateFolder(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = item.id
      this.editFolderMode = true
      this.folderModal = true
    },

    getFile(item) {
      this.$emit('get-file', item)
    },

    validateDoc(item) {
      this.$emit('validate-doc', item)
    },

    deleteDocument(item) {
      this.$emit('delete-document', item)
    },

    deleteFolder(item) {
      this.$emit('delete-folder', item)
    },

    addToDownloadList(item) {
      this.$emit('add-to-download-list', item)
    },

    openAddFolderModal(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.parentFolderId = item ? item.id : null
      this.folderModal = true
    },

    openAddDocModal(item) {
      this.selectedDocument = {}
      this.selectedFolderId = item ? item.id : null
      this.documentDialogKey = !this.documentDialogKey
      this.documentModal = true
    },
  },
}
</script>

<style scoped>
.my-folder-list {
  max-height: 400px;
  overflow-y: auto;
}

.my-folder-list::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 20px;
}

.my-folder-list::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 3.5px;
}

.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
